import logo from '../../assets/Logo.png'
import { Link, useNavigate } from "react-router-dom";

export default function Logo(props){

    return (
        <div className="Logo">
            <Link to='/'>
                <img src={logo} alt="Logo" />
            </Link>           
        </div>
    )
}